import React from 'react';

import './styles.css';

/*
onClick here is optional because we may want to stop propagation of onClick on parent element
when there are other events in children - onChange, onFocus, ..
*/
interface ClickIconWithNoPropagationProps {
  children: any;
  onClick?: (event: React.MouseEvent) => void;
}

const ClickIconWithNoPropagation = ({
  children,
  onClick
}: ClickIconWithNoPropagationProps) => (
  <div
    className="ClickIconWithNoPropagation colab-centered"
    onClick={event => {
      event.stopPropagation();
      return onClick && onClick(event);
    }}>
    {children}
  </div>
);

export default ClickIconWithNoPropagation;
